// import "@babel/polyfill";
import 'what-input';
// jQuery.
import './lib/jquery-global';
// Foundation modules.
import './lib/foundation-explicit-pieces';

import { component as initialiser } from "./components/axis-javascript-initialiser";

// Loop through all the dependancies loading them.
components.initialise().then((list) => {
  //console.log("The following components have been successfully loaded", list);
  AXISDebug.initialise();
  // Output environment information.
  AXISDebug.environmentInfo();
});

// Initialise various js modules.
initialiser.initialise();

// General modules that used around the site.
import './lib/axis-utlis';
// PWA State Detection
AXISPWA.detect();
// ----- Content Refresh initialise ----- 
contentRefresh.initialiseAll();

// ----- Components -----  
import './components/bronze/basket';
// JERRY RIGGED CHECKOUT TEMPLATE 1 LOGIC, PLEASE REBUILD AFTER PHASE 1.
import './components/bronze/checkout';
// Attribute filters.
//import './components/axis-product-list';
//--- AXIS Quantity Selectors ---
import { component as AXISProductList } from './components/axis-product-list';
// Make Module Public.
window.AXISProductList = AXISProductList;
// Helper function.
import { component as axisDomainDetection } from "./components/axis-domain-detection";
window.axisDomainDetection = axisDomainDetection;
// GTM Bespoke events.
import { component as axisGTM } from "./components/axis-google-tag-manager";
// Make Module Public.
window.axisGTM = axisGTM;
// GTM Bespoke events.
import { component as axisScrollIntoView } from "./components/axis-scroll-into-view";
// Make Module Public.
window.axisScrollIntoView = axisScrollIntoView;
// Axis footer functionality.
import './components/axis-footer';

Foundation.Interchange.SPECIAL_QUERIES['xxxlarge'] = "only screen and (min-width: 122em)";

$(document).foundation();

// ----- Auto complete -----
// --- Header Search ---
// let predictiveSearch = $('[' + expressSelectors()['axis-predictive-search']['initialise'] + ']');
// // If exists.
// if (predictiveSearch.length) {
//   // Loop through instances.
//   predictiveSearch.each(function() {
//     // Grab context.
//     let context = $(this);
//     // Initialise.
//     let init = search.initialise(context);
//   });
// }

// ----- Modules -----
if ($(expressSelectors()['modules']['cms']).length > 0) {
  let equalise = AXISModules.cmsModuleImageIntialiseAll(expressSelectors()['modules']['cms']);
}

// if ($(expressSelectors()['modules']['equalise-modules']).length > 0) {
  // As we're working across two equalisers at the moment Foundation's and our own there is chance that cell heights can be determined before child equalisers have finished causing the content to overlap the bottom of the cell, this call 825975 sets out to replace this mechanism with our own equalisation functionality which will remove the need to for this.
  // setTimeout(() => {
  //   let equalise = AXISModules.initialiseAll();
  // }, 500);
// }

//----- Product Page -----

favourites.initialise();

// var magnifier = $(expressSelectors()['product']['magnification']);

// if (magnifier.length > 0) {
//   AXISMagnifier.initialise(magnifier);
// }

// var stocklineControls = $(expressSelectors()['product']['stockline-controls']);
// if (stocklineControls.length > 0) {
//   stockline.initaliseStocklineControls(stocklineControls);
// }

// ----- Additional Images ----- 
// Additional image context.
// var additionalImages = $(expressSelectors()['product']['additional-images']);
// if (additionalImages.length > 0) {
//   AXISAdditionalImages.initialise(additionalImages);
// }

// const countdown = expressSelectors()['countdown'];

// if ($(countdown).length > 0) {
//   $(countdown).each(function() {
//     // Store context.
//     let context = $(this);
//     // Initialise countdown.
//     let initialise = AXISCountdown.initialise(context);
//   });
// }

// Simple text replacement for getting the current year.
// Get date.
var date = new Date();
$('[data-get-current-year]').text(date.getFullYear());

// Update url.
const updateUrlSelector = expressSelectors()['update-url'];
// Initialise listeners.

// Trigger update url if exists.
if ($('[' + updateUrlSelector + ']').length > 0) {
  updateUrl.initialise($('[' + updateUrlSelector + ']'));
}



const autoSubmit = expressSelectors()['forms']['auto-submit'];
// Initialise auto submit for forms so if any input inside of the form changes then the form is automatically submitted.
if ($('form[' + autoSubmit + ']').length > 0) {
  $('form[' + autoSubmit + ']').each(function() {
    // Grab context.
    let context = $(this);
    // Initialise onchange listener.
    let initialise = AXISAjax.autoSubmit(context);
  });
}
// Initialise auto submit for a specific input.
let autoSubmitInputs = $('input[' + autoSubmit + '], select[' + autoSubmit + '], textArea[' + autoSubmit + '], a[' + autoSubmit + ']');
if (autoSubmitInputs.length > 0) {
  autoSubmitInputs.each(function() {
    // Grab context.
    let context = $(this);
    // Iniitialise onchange listener.
    let initialise = AXISAjax.autoSubmit(context);
  });
}

// If a non-ajax form submits then output UI blocker.
$('body').on('submit', 'form:not(' + expressSelectors()['forms']['ajax-form'] + ', [data-ajax])', function(event) {
  // Get form context.
  const context = $(this);
  // Check if in a modal.
  const modal = context.parents('[' + expressSelectors()['modals']['modal-context'] + ']');
  // Check whether this form actually posts somewhere e.g. data-form-bind payment-methods.
  if (!context.attr('action') && !context.attr(expressSelectors()['forms']['ajax-form'])) {
    // Check whether we should merge the data in this form with another form.
    if (context.attr(expressSelectors()['forms']['data-bind'])) {
      event.preventDefault();
      const merge = AXISInputs.formDataBindMerge(context);
      // On success then close modal.
      if (merge['success']) {
        if (modal.length) {
            AXISModals.modalClose();
        }
      }
    }
    return true;
  }
  // Build UI Blocker.
  const uiblocker = AXISAjax.getContentBlockSpinner();
  if (AXISDebug.level() >= 3) {
    AXISDebug.output(1,"Forms: Non AJAX form submitted, adding UI blocker", context);
  }
  // Update DOM.
  context.prepend(uiblocker);
  // Check if we need to send an analytics event.
  const analyticsEvents = context.find('[' + expressSelectors()['analytics']['send-on-submit'] + ']');
  if (analyticsEvents.length) {
    // Send events to GTM.
    analyticsEvents.each(function() {
      // Get element context that holds event.
      const element = $(this);
      // Trigger event.
      const event = axisGTM.jQueryTriggerEvent(element);
    });
  }
  $(window).on('beforeunload', function() {
    context.find('[' + expressSelectors()['ajax']['content-block-element'] + ']').remove();
  });
});

// ----- General ajax form submission ----- 
$('body').on('submit', expressSelectors()['forms']['ajax-form'], function(event, extraParamters) {
  // Prevent default behavour.
  event.preventDefault();
  // Bespoke config for AJAX callback mechanism.
  let customConfig = {};
  // Store form context.
  let context = $(this);
  // Form Id.
  let formId = context.attr('id');
  // Fallback.
  if (!formId) {
    formId = context.attr('name');
    if (!formId) {
      AXISDebug.output(2,"Forms: Failed to obtain form Id, no Id or Name attribute assigned.", context);
    }
  }
  // Get form name, this has been retro-fitted for 862840 ( i.e. GTM Form submit event ).
  const formName = context.attr('name');
  // Get form classes.
  let formClasses = context[0].classList;
  // Class list processing.
  if (formClasses.length) {
    formClasses = formClasses.value;
  } 
  // Check to see if submitter context has been passed.
  let submitter = undefined;
  if (extraParamters) {
    // Typically if this submission is being programatically triggered then we pass through the submitter's context manually.
    submitter = (extraParamters.hasOwnProperty('submitter') ? extraParamters['submitter'] : undefined);
  } else {
    // Default have to JS i.e submit button.
    if (event.hasOwnProperty('originalEvent')) {
      submitter = event['originalEvent']['submitter'];
      // Create jQuery object.
      if (submitter) {
        submitter = $(submitter);
      }
    }
  }
  //  TODO: fallback to none jquery?????
  // Add to config.
  if (submitter) {
    customConfig['submitter'] = submitter;
  }
  // If position-reset == true then when the new content is received move user back to top of callback container.
  let positionReset = (context.attr(expressSelectors()['forms']['position-reset']) == 'true');
  // This is on by default.
  if (positionReset == undefined) {
    positionReset = true;
  }
  // Are we going to be updating another container / element with the response.
  let responseContainer = context.attr(expressSelectors()['ajax']['response-context']);
  if (responseContainer) {
    // TODO: you will run into issues if you have multiple elements you want to update with the response, effectively a JSON response but as we don't do that currently so I have not gone down that route yet.
    responseContainer = $('#' + responseContainer);
    // Make sure element can be found in DOM.
    if (responseContainer.length == 0) {
      AXISDebug.output(3,"Forms: Could not find content to be updated in the DOM");
      return false;
    }
  }
  // If any callbacks need to be done before we submit the form then add them to this array.
  let callbacks = [];
  // Detect if Opayo drop-in is within form.
  const opayoDropIn = context.find('[' + expressSelectors()['axis-opayo-drop-in']['instance-id'] + ']');
  if (opayoDropIn.length) {
    // Wait for token callback.
    const opayoTokenCallback = axisPaymentMethods.waitForToken(opayoDropIn);
    // Add to callbacks.
    callbacks.push(opayoTokenCallback);
  }
  // Wait for callbacks to complete.
  Promise.all(callbacks).then((values) => {
    AXISAjax.callback(context, customConfig).then((data) => {
      // Get xhr object.
      let xhr = (data.hasOwnProperty('xhr') ? data['xhr'] : undefined);
      // Get the response.
      let response = (data.hasOwnProperty('data') ? data['data'] : undefined);
      // Fire GTM form submit event.
      if (axisGTM.isGtmInitialised()) {
        // Gather event data.
        const eventData = {};
        // Cannot use the form id previously defined as that has a fallback.
        if (context.attr('id')) {
          eventData['form_id'] = context.attr('id');
        }
        if (formName) {
          eventData['form_name'] = formName;
        }
        if (formClasses) {
          eventData['form_classes'] = formClasses;
        }
        axisGTM.triggerEvent("form-submission", eventData);
      }
      // If no response then but data-update-location is defined then redirect to the new location ( example login ).
      if (response) {
          // Get the container that holds the elements that made the original response.
        let container = (responseContainer ? responseContainer : AXISAjax.getCallbackContainer(context));
        // Is this a JSON response?
        let isJson = AXISAjax.isResponseJSON(xhr);
        // If the data-ajax-content attribute is defined then deposit the response in the element that has an id that matches the value provided.
        if (responseContainer && !isJson) {
          // This is the old functionality where we specify the container id using an attribute expressSelectors()['ajax']['response-context'] instead of using the json response from the server to dictate where in the DOM to update.
          responseContainer.html(response);
        } else if (container.length > 0) {
          // If the response is JSON the use that to update the container(s).
          if (isJson) {
            AXISAjax.update(context, response).then(() => {
            }).catch((error) => {
              AXISDebug.output(3,error);
            });
          } else {
            // Fallback to the original container.
            container.html(response);
          }
        } else {
          if (AXISDebug.level() >= 3) {
            AXISDebug.output(2,"Forms: failed to find callback container to update content the ajax spinner most likely didn't display as well, will just update whatever object is the current context.");
          } 
          context.html(response);
        }
        // Update context as it belongs to the old form.
        // Find find the form with the same id.
        if (container) {
          context = container.find($('#' + context.attr('id')));
        } else {
          // Fallback to response container.
          context = responseContainer.find($('#' + formId));
          if (!context.length) {
            context = responseContainer.find($('[name="' + formId + '"]'));
            if (context.length > 1) {
              context = context.first();
            }
          }
        }
        if (context.length == 0) {
          // If a different form has been passed back then find the new form.
          let form = container.find('form');
          if (form.length > 0) {
            context = form;
          } else {
            // If no form has been passed back ( likely to be success text ) then default the context to the container.
            context = container;
          }
        }
        // If position reset has been set then send the user back to the top of the form.
        if (positionReset) {
          if (container) {
            //Foundation.SmoothScroll.scrollToLoc(container , {offest: 120});
            scrollIntoView(container);
          } else {
            // Fallback to context.
            scrollIntoView(context);
          }
        }
      } 
    }).catch((error) => {
      AXISDebug.output(3,error);
    });
  });
  return false;
});

// Load forms.
let getForms = $('[' + expressSelectors()['forms']['load'] + ']');
if (getForms) {
  // Loop through instances.
  getForms.each(function() {
    // Grab context.
    let context = $(this);
    // Do callback.
    AXISAjax.callback(context).then((data) => {
      // Get response.
      let response = data['data'];
      // Get the container that holds the elements that made the original response.
      let container = AXISAjax.getCallbackContainer(context);
      // Update DOM.
      container.html(response);
    });
  });
}

// Look for any events to sent onload.
let gtmOnloadEvent = axisGTM.onloadEvents();

let initialise = AXISModals.initialiseAll();
// Read more must be initialised after modals to allow for modules positioning to take place.
let readMore = AXISReadMore.initialiseAll();

// ----- CMS Tables ----- 
AXISTypography.initialiseAll();

// var captchaForms = $('form[' + expressSelectors()['axis-captcha']['initialise'] + ']')
// if (captchaForms) {
//   if (AXISDebug.level() >= 3) {
//     AXISDebug.output(1,"Recaptcha: Form(s) found with recaptcha key attribute, attempting to initialise.");
//   }
//   captchaForms.each(function() {
//     // Store context.
//     let context = $(this);
//     // Initialise recaptcha.
//     captcha.initialise(context);
//   });
// }

// ----- Axis Basket ----- 
AXISBasket.initialiseAll();

// ----- Axis Inputs ----- 
AXISInputs.initialise();

// ----- Lookups ----- 
AXISLookups.initialiseAll(1);

// ----- Responsive Menu ------ 
AXISResponsiveMenu.initialise();

$(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
  AXISResponsiveMenu.resize();
});

// ----- Quantity Selectors -----
AXISQuantitySelectors.initialiseAll();

// ----- Sliders -----
AXISSliders.initialiseAll();

// ----- PWA -----
window.pwaInstall = () => {
  // Get notification context.
  let context = $('[' + expressSelectors()['axis-pwa']['initialise'] + ']');
  // Initialise PWA install.
  let install = AXISPWA.install(context);
};

// ----- Callouts ----- 
callouts.initialiseAll();

// ----- Tooltip ----- 
AXISTooltip.initialiseAll();

// ----- Message Events ----- 
messageEvents.initialise();

// ----- Stock Indicators ----- 
stockIndicators.initialiseAll();

// ----- Axis Sticky -----
AXISSticky.initialiseAll();

// ----- Animations ----- 
// Initialise.
// animations.initialiseAll();

// ----- Axis Table Of Contents -----
AXISTableOfContents.initialiseAll();

// ---- Serivce Worker ----- 
// Initialise service worker required for PWA support.
AXISServiceWorker.initialise();

// ----- vmAdmin -----
// vmadmin.initialiseAll();

// ----- Style guide initialise -----
styleguide.initialiseAll();


$(window).on('load', function() {
  // ----- Axis Equaliser ----- 
  equaliser.initialiseAll();
  // ----- Scroll into view ----
  const scrollIntoViewElement = $('[' + expressSelectors()['axis-scroll-into-view']['initialise'] + ']');
  if (scrollIntoViewElement.length) {
    axisScrollIntoView.initialise(scrollIntoViewElement);
  }
});

// ----- Carousels ----- 
// carousels.initialiseAll();

// ----- Back to top button initialise ----- 
backToTop.initialiseAll();

// ----- Sections initialise -----
sections.initialiseAll();

// ----- Ellipsis initialise ----- 
ellipsis.initialiseAll();

// ----- Text initialise -----
// DEPRICATED: Using axis-table-column-equaliser instead.
// tableTextEqualiser.initialiseAll();

// -----  Table Column Equaliser -----
AXISTableColumnEqualiser.initialiseAll();

// ----- Axis toggler initialise -----
AXISToggler.initialiseAll();

// ----- Axis Mega Menu initialise -----
// AXISMegaMenu.initialiseAll();

// ----- Axis Tree Menu initialise ----- 
// treeMenu.initialiseAll();

// ----- Axis Geolocation initialise ----- 
AXISGeoLocation.initialiseAll();

// ----- Axis Interactive Maps -----
// AXISInteractiveMaps.initialiseAll();

// ----- Axis Barcode Scanner ----- 
// axisBarcodeScanner.initialiseAll();

// ----- Axis Mobile Menus -----
AXISMobileMenus.initialiseAll(); 


// This is here for test purposes.
$('body').on('click', '[data-reauthentication-cancelled-button]', function(event) {
  // Prevent default behavour.
  event.preventDefault();
  AXISAjax.reauthentication("reauthentication-cancelled");
});


// Test put in place for 810781 to demonstrate Cross Origin communication between tabs.
var newWindow;
$('[data-open-window]').on('click', function() {
  let context = $(this);
  // Location / destination of the user.
  let url = context.attr('data-url');
  /*
  
  There is a "bug/feature" in Safari/iOS preventing re-focussing tabs that have been previously opened. 

  https://stackoverflow.com/questions/56276312/window-focus-doesnt-work-on-existing-tabs-in-ios-safari
  https://discussions.apple.com/thread/251676767?sortBy=rank
  */
  if (newWindow) {
    console.log("closing existing window");
    newWindow.close();
  }
  newWindow = window.open((url ? url : ""),"reauthenticationWindow");
  newWindow.focus();
});

// If running in standalone mode ( PWA )  for cross domain links to open in new tab.
if (isRunningStandalone()) {
  $('body').on('click', 'a[href]', function(event) {
    // Context.
    const context = $(this);
    // Get Url.
    const url = context.attr('href');
    if (url) {
      // Check whether url is cross origin request.
      const isCrossOrigin = axisDomainDetection.isCrossOrigin(url);
      if (AXISDebug.level() >= 3) {
        AXISDebug.output(2,"Anchors: Cross-orgin anchor click, opening in new tab", context);
      }
      console.log("Cross origin fetch request", isCrossOrigin);
      if (isCrossOrigin) {
        event.preventDefault();
        window.open(url, '_blank' , 'noopener');
      }
    }
  });
}
//DC JS BLOCKED
document.documentElement.classList.add('js-ready');